import styled from "styled-components"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/tabs"
import { Button } from "../../../ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../../../ui/dropdown-menu"
import { Input } from "../../../ui/input"
import SimpleTable from '../../components/SimpleTable'
import { Checkbox } from "../../../ui/checkbox"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../../../ui/select"

const CheckOut = () => {

    const ClaimsDataSource = [
        {
            key: '1',
            title: 'Issue 1',
            notes: 'Details about issue 1',
            createdOn: '2023-06-01',
            updatedOn: '2023-06-02',
            resolution: 'Resolved',
        },
        {
            key: '2',
            title: 'Issue 2',
            notes: 'Details about issue 2',
            createdOn: '2023-06-03',
            updatedOn: '2023-06-04',
            resolution: 'Unresolved',
        },
    ];


    const ClaimsColumns = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
        },
        {
            title: 'Created on',
            dataIndex: 'createdOn',
            key: 'createdOn',
        },
        {
            title: 'Updated on',
            dataIndex: 'updatedOn',
            key: 'updatedOn',
        },
        {
            title: 'Resolution',
            dataIndex: 'resolution',
            key: 'resolution',
        },
    ];

    const CheckOutColumns = [
        {
            title: '到期日',
            dataIndex: 'dueDate',
            key: 'dueDate',
        },
        {
            title: '書名',
            dataIndex: 'bookName',
            key: 'bookName',
        },
        {
            title: '種類',
            dataIndex: 'category',
            key: 'category',
        },
        {
            title: '原圖書館',
            dataIndex: 'originalLibrary',
            key: 'originalLibrary',
        },
        {
            title: '借出日期',
            dataIndex: 'borrowDate',
            key: 'borrowDate',
        },
        {
            title: '借出圖書館',
            dataIndex: 'borrowLibrary',
            key: 'borrowLibrary',
        },
        {
            title: '費用',
            dataIndex: 'fee',
            key: 'fee',
        },
        {
            title: '罰金',
            dataIndex: 'fine',
            key: 'fine',
        },
        {
            title: '總額',
            dataIndex: 'totalAmount',
            key: 'totalAmount',
        },
        {
            title: '再出借',
            dataIndex: 'renewal',
            key: 'renewal',
        },
        {
            title: '還書',
            dataIndex: 'returnBook',
            key: 'returnBook',
        },
    ];

    const CheckOutDataSource1 = [
        {
            dueDate: '2024-06-30',
            bookName: 'JavaScript: The Good Parts',
            category: 'Programming',
            originalLibrary: 'Library A',
            borrowDate: '2024-06-10',
            borrowLibrary: 'Library B',
            fee: 10,
            fine: 2,
            totalAmount: 12,
            renewal: true,
            returnBook: '2024-06-25',
        },
        {
            dueDate: '2024-07-15',
            bookName: 'Introduction to Algorithms',
            category: 'Computer Science',
            originalLibrary: 'Library C',
            borrowDate: '2024-06-01',
            borrowLibrary: 'Library D',
            fee: 15,
            fine: 3,
            totalAmount: 18,
            renewal: false,
            returnBook: '2024-07-10',
        },
    ];

    const MessagingPrefrerncesCoiumns = [
        {
            title: '偏好',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: '提前幾天通知',
            dataIndex: 'DaysInAdvance',
            key: 'DaysInAdvance',
        },
        {
            title: '電子郵件',
            dataIndex: 'Email',
            key: 'Email',
        },
        {
            title: '僅限摘要',
            dataIndex: 'Digests',
            key: 'Digests',
        },
    ]

    const MessagingPrefrerncesSource = [
        {
            title: '物品到期',
            DaysInAdvance: '-',
            Email: <Checkbox disabled />,
            Digests: <Checkbox disabled />
        },
        {
            title: '提前通知',
            DaysInAdvance:
                <Select defaultValue="1" disabled>
                    <SelectTrigger className="w-20 h-8">
                        <SelectValue/>
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="1">1</SelectItem>
                        <SelectItem value="2">2</SelectItem>
                        <SelectItem value="3">3</SelectItem>
                    </SelectContent>
                </Select>,
            Email: <Checkbox disabled />,
            Digests: <Checkbox disabled />
        },
        {
            title: '預約到書通知',
            DaysInAdvance: '-',
            Email: <Checkbox disabled />,
            Digests: <Checkbox disabled />
        },
        {
            title: '物品歸還',
            DaysInAdvance: '-',
            Email: <Checkbox disabled />,
            Digests: '-'
        },
        {
            title: '物品借出',
            DaysInAdvance: '-',
            Email: <Checkbox disabled />,
            Digests: '-'
        },
        {
            title: '預約提醒',
            DaysInAdvance: '-',
            Email: <Checkbox disabled />,
            Digests: '-'
        },
    ]

    const ContectItem = [
        {
            title: '電話',
            text: '0987654321'
        },
        {
            title: 'Email',
            text: 'mail@mail.com'
        },
        {
            title: '生日',
            text: '2000/1/1'
        },
        {
            title: '顯示借閱信息給擔保人',
            text: '是'
        },
        {
            title: '顯示收費信息給擔保人',
            text: '否'
        },
    ]

    const LibraryUse = [
        {
            title: '卡號',
            text: '9235'
        },
        {
            title: '借閱者號碼',
            text: '3'
        },
        {
            title: '類別',
            text: '測試用群組 (TEST)'
        },
        {
            title: '註冊日期',
            text: '2024年4月22日'
        },
        {
            title: '到期日期',
            text: '2025年4月22日'
        },
        {
            title: '圖書館',
            text: '介壽校區'
        },
        {
            title: '隱私偏好',
            text: '永久'
        },
        {
            title: '用戶名',
            text: '9235'
        },
        {
            title: '密碼',
            text: '******'
        },
        {
            title: '密碼到期',
            text: '永不'
        },
        {
            title: '受保護',
            text: '否'
        },
    ]

    const AlternateContact = [
        {
            title: '名字',
            text: 'Cena'
        },
    ]

    return (
        <MainContainer>

            <ButtonGroup>
                <Button variant="outline" >編輯</Button>
                <Button variant="outline" >更改密碼</Button>
                <Button variant="outline" >複製</Button>
                <Button variant="outline" >搜尋預留</Button>
                <DropdownMenu>
                    <DropdownMenuTrigger><Button variant="outline" >列印</Button></DropdownMenuTrigger>
                    <DropdownMenuContent>
                        <DropdownMenuItem>Print Summary</DropdownMenuItem>
                        <DropdownMenuItem>Print Slip</DropdownMenuItem>
                        <DropdownMenuItem>Print quick Slip</DropdownMenuItem>
                        <DropdownMenuItem>Print Checkin Slip</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
                <Button variant="outline" >新增訊息</Button>
                <DropdownMenu>
                    <DropdownMenuTrigger><Button variant="outline" >更多</Button></DropdownMenuTrigger>
                    <DropdownMenuContent>
                        <DropdownMenuItem>Renew Patron</DropdownMenuItem>
                        <DropdownMenuItem>Set Permissions</DropdownMenuItem>
                        <DropdownMenuItem>Manage API Key</DropdownMenuItem>
                        <DropdownMenuItem>Send Welcome email</DropdownMenuItem>
                        <DropdownMenuItem>Delect</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </ButtonGroup>
            <WhiteBox>
                <SubTitle>訊息</SubTitle>
                <Button variant="link">+ 新增訊息</Button>
            </WhiteBox>
            <Title>Little John</Title>
            <LanContainer>
                <VerContainer>
                    <WhiteBox>
                        <SubTitle>聯絡信息</SubTitle>
                        <SimpleList item={ContectItem} />
                    </WhiteBox>
                    <WhiteBox>
                        <SubTitle>訊息偏好</SubTitle>
                        <SimpleTable columns={MessagingPrefrerncesCoiumns} dataSource={MessagingPrefrerncesSource} />
                    </WhiteBox>
                </VerContainer>
                <VerContainer>
                    <WhiteBox>
                        <SubTitle>圖書館相關</SubTitle>
                        <SimpleList item={LibraryUse} />
                    </WhiteBox>
                    <WhiteBox>
                        <SubTitle>替代地址</SubTitle>
                        <div>代理人地址</div>
                    </WhiteBox>
                    <WhiteBox>
                        <SubTitle>替代聯絡人</SubTitle>
                        <SimpleList item={AlternateContact} />
                    </WhiteBox>
                </VerContainer>
            </LanContainer>
            <Tabs defaultValue="0" className="w-full">
                <TabsList>
                    <TabsTrigger value="0">已出借</TabsTrigger>
                    <TabsTrigger value="1">預約</TabsTrigger>
                    <TabsTrigger value="2">聲明</TabsTrigger>
                    <TabsTrigger value="3">限制</TabsTrigger>
                    <TabsTrigger value="4">讀者列表</TabsTrigger>
                </TabsList>
                <TabsContent value="0">
                    <WhiteBox>
                        <SimpleTable columns={CheckOutColumns} dataSource={CheckOutDataSource1} />
                    </WhiteBox>
                </TabsContent>
                <TabsContent value="1">
                    <WhiteBox>
                        <SimpleTable columns={CheckOutColumns} dataSource={CheckOutDataSource1} />
                    </WhiteBox>
                </TabsContent>
                <TabsContent value="2">
                    <WhiteBox>
                        <SimpleTable columns={ClaimsColumns} dataSource={ClaimsDataSource} />
                    </WhiteBox>
                </TabsContent>
                <TabsContent value="3">
                    <WhiteBox>
                        <div>
                            <span>Patron is currently unrestricted.</span>

                        </div>
                        <Button variant="link">手動新增限制</Button>
                    </WhiteBox>
                </TabsContent>
                <TabsContent value="4">
                    <WhiteBox>
                    </WhiteBox>
                </TabsContent>
            </Tabs>
        </MainContainer>
    )
}

const SimpleList = ({ 
    item = [
        {
            title: 'title',
            text: 'text',
        }
    ] 
}) => {
    return(
        item.map( (e) => {
            return(
                <ListBox>
                    <ListTitle>
                        {e.title}
                    </ListTitle>
                    <ListText>
                        {e.text}
                    </ListText>
                </ListBox>
            )
        }
        )
    )
}

const ListTitle = styled.div`
    font-weight: 700;
    width: 10em;
    margin: 0.2em 1em 0.2em 0.2em;
`

const ListText = styled.div`
    margin: 0.2em;
`

const ListBox = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    border-bottom: 1px solid #cdcdcd;
`

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
// padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const LanContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
gap: 0.5em;
flex-wrap: nowrap;
`

const VerContainer = styled.div`

width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
gap: 0.5em;
flex-wrap: nowrap;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.1em;
font-weight: 600;
padding-bottom: 0.5em;
}
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`
const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
width: -webkit-fill-available;
`
const GrayText = styled.span`
color: #929292;
`
const Title = styled.div`
text-align: left;
width: 90%;
font-size: 1.6em;
font-weight: 700;
}
`

export default CheckOut